import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import { NgZone } from '@angular/core';
import posthog from 'posthog-js';
import { SegmentService } from 'ngx-segment-analytics';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  constructor(private ngZone: NgZone, private segmentService: SegmentService) { }

  loadAppConfig(): Promise<void> {
    if (environment.config?.segment?.apiKey) {
      try {
        this.segmentService.load({
          writeKey: environment.config.segment.apiKey,
          cdnURL: environment.config.segment.cdnURL,
        }, {integrations: {
          'Segment.io': {
            apiHost: environment.config.segment.apiHost,
            protocol: 'https'
          }
        }});

        // Add middleware to inject PostHog session ID into all Segment events
        // This allows PostHog to correlate events with session recordings
        this.segmentService.ready().then(() => {
          this.segmentService.addSourceMiddleware(({ payload, next }: any) => {
            // Get PostHog session ID and add it to event properties
            if (typeof posthog !== 'undefined' && posthog.get_session_id) {
              payload.obj.properties = {
                ...payload.obj.properties,
                $session_id: posthog.get_session_id(),
              };
            }
            next(payload);
          });
        });
      } catch (error) {
        console.error('Failed to initialize Segment:', error);
      }
    }

    try {
      if (typeof FB !== 'undefined') {
        FB.init({
          appId: environment.config.fbAppId,
          cookie: true,
          xfbml: true,
          version: environment.config.fbVersion
        });
      } else {
        console.log('AppConfigService: Facebook SDK not available');
      }
    } catch (error) {
      console.error('Failed to initialize Facebook SDK:', error);
    }

    try {
      this.ngZone.runOutsideAngular(() => {
        posthog.init(environment.config.posthog.apiKey, {
            api_host: environment.config.posthog.host,
            ui_host: 'https://eu.posthog.com',
            debug: false,
            cross_subdomain_cookie: true,
            defaults: '2025-05-24',
            autocapture: false,
            capture_pageview: false
        });
      });
    } catch (error) {
      console.error('Failed to initialize PostHog:', error);
    }

    return Promise.resolve();
  }
}
